"use strict";exports.__esModule=!0,exports["default"]=function(e){e.registerHelper("lookup",function(e,t){return e&&e[t]})},module.exports=exports["default"];